<template>
  <b-card
    class="mb-5 search-results ps-3 pt-3"
    v-if="searchQuery.length && searchQuery.length > minQueryLength"
    no-body
  >
    <div v-if="results.length < maxResults">
      <puls-navigation-list :max-text-length="220" :items="results" />
    </div>

    <b-card-body v-if="results.length === 0 && searchQuery.length" class="p-2">
      {{ $t('home.search.results.nothing') }}
    </b-card-body>
    <b-card-body
      v-if="results.length >= maxResults && searchQuery.length"
      class="p-2"
    >
      {{ $t('home.search.results.toomany') }}
    </b-card-body>
  </b-card>
</template>

<script>
import Fuse from 'fuse.js'
let fuse
export default {
  name: 'SearchResults',
  props: {
    articleData: Array,
    searchQuery: String,
    fuseIndex: Object,
    fuseOptions: Object
  },
  data: () => {
    return {
      maxResults: 25,
      minQueryLength: 0
    }
  },
  created() {
    fuse = new Fuse(this.articleData, this.fuseOptions, this.fuseIndex)
  },
  computed: {
    results() {
      const res = fuse.search(this.searchQuery)

      return res.map((r) => ({
        ...r.item,
        to: {
          name: 'Article',
          params: { section: r.item.section, article: r.item.article }
        }
      }))
    }
  }
}
// rgba(var(--kt-card-bg), 1);
</script>

<style scoped>
.search-results {
  background-color: var(--kt-input-bg);
  max-height: 60vh;
  overflow: scroll;
  position: absolute;
  z-index: 600;
  filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.5));
}
</style>

<style>
.search-results .separator {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}
</style>
